import _ from 'lodash';
import React from 'react';

import { ChartTimePeriod } from './portfolioChartUtils';
import { CsvXlsxDownloadSelect } from 'packages/common-frontend/components/CsvXlsxDownloadSelect';

export interface CsvDownloadLinkProps {
  dataRows: { [key: string]: any }[];
  headers: { label: string; key: any }[];
  chartTitle: string;
  selectedTimePeriod: ChartTimePeriod;
  // !TODO @eldarshamukhamedov Remove when all charts are migrated to standard chart components
  MenuButtonProps?: React.ComponentProps<
    typeof CsvXlsxDownloadSelect
  >['MenuButtonProps'];
}

export const PortfolioDownloadCsvLink = ({
  dataRows,
  headers,
  chartTitle,
  selectedTimePeriod,
  MenuButtonProps,
}: CsvDownloadLinkProps) => {
  const filenamePrefix = `${_.snakeCase(
    chartTitle,
  )}-by-${selectedTimePeriod}.csv`;

  return (
    <CsvXlsxDownloadSelect
      dataRows={dataRows}
      headers={headers}
      filenamePrefix={filenamePrefix}
      MenuButtonProps={{ mt: '24px', ...MenuButtonProps }}
    />
  );
};
